import OrganizationDocument from "./organizationDocument";

export default class ObjectModel extends OrganizationDocument {
  modelKey = 'object_model';
  collectionKey = 'object_models';

  static get displayName(): string {
    return 'Object Model';
  }

  get isObjectModel(): boolean {
    return true;
  }

  get classKey(): string {
    return 'objectModel';
  }

  get rootName(): string {
    return 'objectModel';
  }

  get titleOrDefault(): string {
    if (this.title && this.title.length > 0) {
      return this.title;
    } else {
      return "Untitled Object Model";
    }
  }


}